import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Admin } from './routes/Admin.js';
import { Casino } from './routes/Casino.js';
import { Host } from './routes/Host.js';
import { Play } from './routes/Play.js';
import { Profile } from './routes/Profile.js';
import { Landing } from './routes/Landing.js';
import { Receiver } from './routes/Receiver.js';
import { RokuLanding } from './routes/RokuLanding.js';
import { applyLiteMode } from './lib/liteMode.js';
import { referralRef } from './lib/storage.js';
import './styles/global.css';

// Before the first render, so a weak cast device never paints the full effects.
applyLiteMode();
// Any page can be a referral link, so the code is caught before routing.
referralRef.capture(window.location.search);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/roku" element={<RokuLanding />} />
        <Route path="/casino" element={<Casino />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/host" element={<Host />} />
        <Route path="/tv" element={<Host />} />
        <Route path="/play" element={<Play />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/receiver" element={<Receiver />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
